import { useAppSelector } from '../../app/typedReduxHooks'
import { CognitoPatientWorkflow } from './CognitoPatientWorkflow'
import { EhrResolvedPatientPanel } from './EhrResolvedPatientPanel'

const ProviderAwarePatientDetailsPanel = () => {
  const provider = useAppSelector((state) => state.authenticatedProvider)

  if (provider === 'unknown') {
    return null
  }

  return provider === 'ehr' ? <EhrResolvedPatientPanel /> : <CognitoPatientWorkflow />
}

export default ProviderAwarePatientDetailsPanel
